module.exports = __webpack_public_path__ + "static/media/box-xl.cead4ecf.png";